<template>
	<div>
		<!--<v-select label="fonction" v-model="search" :options="data"></v-select>
		{{ search }}

		<hr />-->

		<b-input v-model="search" :list="'list'"></b-input>
		<datalist :id="'list'">
			<option v-for="(option, idx) in data" :key="'c' + idx"  :value="option.fonction">{{ option.type }} - {{ option.fonction }} - {{ option.niveau }}</option>
		</datalist>
		<p>
			Type <br />
			<b-form-radio inline v-model="type" name="name">&nbsp;</b-form-radio>
			<b-form-radio inline v-for="(option, idx) in [...new Set(initial_data.map(item => item.type))]" :key="idx" v-model="type" name="name" :value="option">{{ option }}</b-form-radio>
		</p>

		Type
		<v-select label="fonction" v-model="type" :options="[...new Set(initial_data.map(item => item.type))]"></v-select>

		<br />

		<div v-html="text"></div>

		<edit_tabulator ref="tabulator" :extern_file="false" :columns_type="{fonction: {type: 'list'}}"></edit_tabulator>

	</div>
  </template>
  
  <script>

  import alasql from "alasql";

  import edit_tabulator from "../components/edit_tabulator.vue";

  export default {
	components: {
		edit_tabulator
	},
	data () {
	  return {
		initial_data: [
			{ type: "marketing", fonction: "Directeur marketing", niveau: "Direction"},
			{ type: "marketing", fonction: "Responsable marketing", niveau: "Cadre / management"},
			{ type: "marketing", fonction: "Chef de produit", niveau: "Cadre / expert"},
			{ type: "it", fonction: "Chef de produit", niveau: "Cadre / expert"},
			{ type: "it", fonction: "CTO", niveau: "Direction"}
		],
		data: [],
		search: "",
		type: "",
		request: "",
		text: "{{ initial_data }}"
	  }
	},
	watch: {
		type() {
			this.request = "";
			if (this.type)
				this.request = "where type = '" + this.type + "'"
			this.data = alasql(
				"SELECT * FROM ? " + this.request,
				[this.initial_data]
			);
		}
	},
	methods: {
	},
	async mounted() {

		this.data = alasql(
			"SELECT * FROM ? " + this.request,
			[this.initial_data]
		);

		this.$refs.tabulator.set_data([{
			poste: "Chef informatique",
			fonction: ""
		},{
			poste: "Responsable produit",
			fonction: ""
		}]);

	}
  };
  </script>